import { LoadingState } from "@/mk2/reducers/loadingState";

import {
    GroupReportedFeedPageState,
    GroupReportedFeedState,
    GroupReportedFeedVirtualPageState,
    PostsState,
} from "./GroupReportedFeed.reducers";

export const GROUP_REPORTED_FEED_MENU_MORE = "group-feed-more";

export const initialGroupReportedFeedPageState: GroupReportedFeedPageState = {
    postIds: null,
    eshopProductsIds: null,
    errorMessage: null,
    loadingState: LoadingState.INIT,
};

export const initialGroupReportedFeedVirtualPageState: GroupReportedFeedVirtualPageState = {
    errorMessage: null,
    loadingState: LoadingState.INIT,
};

export const initialPostsState: PostsState = {
    count: 0,
    pages: {},
    virtualPages: {},
    numberOfPages: null,
};

export const initialGroupReportedFeedState: GroupReportedFeedState = {
    commentsLoadingState: LoadingState.INIT,
    errorMessage: null,
    isBlocked: false,
    isSubscribed: false,
    moderators: [],
    recentContributors: 0,
    posts: initialPostsState,
};

export const emptyComplaintsCounts = {};
